import { render, staticRenderFns } from "./AudiencePreview.vue?vue&type=template&id=5c31082e&scoped=true&"
import script from "./AudiencePreview.vue?vue&type=script&lang=js&"
export * from "./AudiencePreview.vue?vue&type=script&lang=js&"
import style0 from "./AudiencePreview.vue?vue&type=style&index=0&id=5c31082e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31082e",
  null
  
)

export default component.exports